// Day js
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
// Translation
import i18n from "i18next";
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { initReactI18next, useTranslation } from "react-i18next";
// React
import { useEffect } from "react";
// React router dom
import { Route, Routes, useLocation, useNavigationType } from "react-router-dom";
// Pages
import Home from "./pages/Home/Home";
import InProgress from "./pages/InProgress/InProgress";
import DiagnosticReports from "./pages/DiagnosticReports/DiagnosticReports";
import ErrorPage from "./pages/Error/Error";
import { toPublicUrl } from './services/PublicUrl';
import ImplementationGuidePage from './pages/ImplementationGuide/ImplementationGuidePage';

require('dayjs/locale/fr');

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: ['fr', 'en'],
    backend: {
      loadPath: toPublicUrl("/locales/{{lng}}/{{ns}}.json"),
    },
  })

dayjs.extend(relativeTime);
dayjs.locale(i18n.language);

function App() {
  const action = useNavigationType();
  const location = useLocation();
  const pathname = location.pathname;

  useTranslation();

  useEffect(() => {
    if (action !== "POP") {
      window.scrollTo(0, 0);
    }
  }, [action, pathname]);

  useEffect(() => {
    let title = "";
    let metaDescription = "";

    switch (pathname) {
      case "/":
      case "/Apollo":
      case "/Home":
      case "/Apollo/Home":
        title = "Home page";
        metaDescription = "";
        break;
      case "/InProgress":
        title = "Coming Soon";
        metaDescription = "";
        break;
      case "/DiagnosticReports":
        title = "Diagnostic reports";
        metaDescription = "";
        break;
      case "/ImplementationGuide":
        title = "FHIR Implementation Guide";
        metaDescription = "";
        break;
      case "/Error":
        title = "Error";
        metaDescription = "";
        break;
    }

    if (title) {
      document.title = title;
    }

    if (metaDescription) {
      const metaDescriptionTag: HTMLMetaElement | null = document.querySelector(
        'head > meta[name="description"]'
      );
      if (metaDescriptionTag) {
        metaDescriptionTag.content = metaDescription;
      }
    }
  }, [pathname]);

  return (
    <Routes>
      <Route index element={<Home />} />
      <Route
        path="/"
        element={<Home />}
      />
      <Route
        path="/Home"
        element={<Home />}
      />
      <Route
        path="/Apollo"
        element={<Home />}
      />
      <Route
        path="/Apollo/Home"
        element={<Home />}
      />
      <Route
        path="/InProgress"
        element={<InProgress />}
      />
      <Route
        path="/Error"
        element={<ErrorPage />}
      />
      <Route
        path="/DiagnosticReports"
        element={<DiagnosticReports />}
      />
      <Route 
        path="/ImplementationGuide" 
        element={<ImplementationGuidePage />} 
      />
      <Route path="*" element={<ErrorPage notFound />} />
    </Routes>
  );
}

export default App;
